
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/category/[slug]",
      function () {
        return require("private-next-pages/recipes/category/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/category/[slug]"])
      });
    }
  